// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__ZLFr_","rightAdornment":"Header_rightAdornment__1IjaV"};